export type ConsentCategoryT =
  | "necessary"
  | "functional"
  | "analytics"
  | "marketing";

export type ConsentPreferencesT = {
  necessary: true; // Always true by definition and not user-toggleable
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
};

export type ConsentStateT = {
  version: number;
  decided: boolean; // Whether the user made an explicit decision
  preferences: ConsentPreferencesT;
  // In-memory only overrides for the current session (not persisted)
  sessionOverrides?: Partial<Record<ConsentCategoryT, boolean>>;
};

export const CONSENT_COOKIE_NAME = "cookie_consent";
export const CONSENT_VERSION = 1;

export const DEFAULT_CONSENT: ConsentStateT = {
  version: CONSENT_VERSION,
  decided: false,
  preferences: {
    necessary: true,
    functional: false,
    analytics: false,
    marketing: false,
  },
};
